import React, { useState } from "react";
import axios from "axios";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function AdminLogin() {

  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const [message, setMessage] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const [showPassword, setShowPassword] =
    useState(false);

  const handleLogin =
    async (e) => {

      e.preventDefault();

      try {

        setLoading(true);

        const res =
          await axios.post(
            `${BASE_API}/admin/login2`,
            {
              email,
              password
            }
          );

        if (res.data.success) {

          localStorage.setItem(
            "adminToken",
            res.data.token
          );

          localStorage.setItem(
            "userRole",
            res.data.role
          );

          setMessage("");

          window.location.href =
            "/dashboard";

        }

      } catch (error) {

        setMessage(
          error.response?.data?.message ||
          "Login failed"
        );

      } finally {

        setLoading(false);

      }

    };

  return (

    <div style={styles.container}>

      <form
        onSubmit={handleLogin}
        style={styles.form}
      >

        <h2 style={styles.title}>
          Admin Login
        </h2>

        <p style={styles.subtitle}>
          Secure admin access
        </p>

        <input
          type="email"
          placeholder="Admin Email"
          required
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
          style={styles.input}
        />

        {/* PASSWORD */}

        <div style={styles.passwordWrapper}>

          <input
            type={
              showPassword
                ? "text"
                : "password"
            }
            placeholder="Password"
            required
            value={password}
            onChange={(e) =>
              setPassword(
                e.target.value
              )
            }
            style={styles.passwordInput}
          />

          <span
            style={styles.eye}
            onClick={() =>
              setShowPassword(
                !showPassword
              )
            }
          >
            {showPassword ? "🙈" : "👁"}
          </span>

        </div>

        <button
          style={
            loading
              ? styles.buttonDisabled
              : styles.button
          }
          disabled={loading}
        >
          {loading
            ? "Logging in..."
            : "Login"}
        </button>

        {message && (
          <p style={styles.error}>
            {message}
          </p>
        )}

      </form>

    </div>

  );

}

const styles = {

  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    fontFamily:
      "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
    background:
      "linear-gradient(135deg, #1e3c72, #2a5298)"
  },

  form: {
    width: "100%",
    maxWidth: "380px",
    background: "#ffffff",
    padding: "35px",
    borderRadius: "14px",
    boxShadow:
      "0 10px 30px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column"
  },

  title: {
    textAlign: "center",
    color: "#1e3c72",
    fontSize: "26px",
    fontWeight: "600",
    marginBottom: "5px"
  },

  subtitle: {
    textAlign: "center",
    color: "#666",
    marginBottom: "25px",
    fontSize: "14px"
  },

  input: {
    width: "90%",
    padding: "13px",
    marginBottom: "16px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "15px",
    outline: "none"
  },

  passwordWrapper: {
    position: "relative",
    marginBottom: "16px"
  },

  passwordInput: {
    width: "90%",
    padding: "13px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "15px",
    outline: "none"
  },

  eye: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    fontSize: "18px"
  },

  button: {
    width: "100%",
    padding: "14px",
    background:
      "linear-gradient(90deg,#1e3c72,#2a5298)",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer"
  },

  buttonDisabled: {
    width: "100%",
    padding: "14px",
    background: "#ccc",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "not-allowed"
  },

  error: {
    marginTop: "15px",
    textAlign: "center",
    color: "red",
    fontSize: "14px"
  }

};